<div mat-dialog-content class="form-container">
    <form  class="form__datosCentroContratista">
      <h1>Solicitud de ampliación de centros</h1>

      <h2>Seleccione al contratista que desea ampliar su número de centros<br> y la cantidad de centros.</h2>
      <div class="datos__datos">
        <mat-form-field appearance="outline">

          <mat-label>Seleccionar Contratista</mat-label>
          <mat-select name="contratista" [(value)]="contratistaSeleccionado">
            <mat-option *ngFor="let contratista of contratistas" [value]="contratista">
              {{contratista.nombreComercial}}
            </mat-option>
          
        </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="centros">
            <mat-label>Nº de Centros </mat-label>
            <input matInput type="number"  required min="1" [(ngModel)]="numCentros" name="number"/>
            <mat-error>Campo Obligatorio, por favor introduzca el número de centros</mat-error>
          </mat-form-field>
      </div>
      <button type="submit"  [mat-dialog-close] (click)="sendSolicitud()">
        Hecho
      </button>
    </form>

    </div>
